function initDefaultTabs() {
    const tabs = document.querySelectorAll('.js-tabs');
    tabs &&
        tabs.forEach((item) => {
            const navs = item.querySelectorAll('.js-tab-link');
            navs &&
                navs.forEach((btn) => {
                    btn.addEventListener('click', (event) => {
                        console.log('ok');
                        event.preventDefault();
                        const container = event.target;
                        const currentTab = container.dataset.nav;
                        if (currentTab) {
                            const currentTabs = item.querySelectorAll('.js-tab');
                            currentTabs &&
                                currentTabs.forEach((tab) => {
                                    tab.classList.remove('active');
                                });
                            const activeTab = item.querySelectorAll(`div[data-tab="${currentTab}"]`);
                            activeTab &&
                                activeTab.forEach((tab) => {
                                    tab.classList.add('active');
                                });
                            navs.forEach((btnOld) => {
                                btnOld.classList.remove('active');
                            });
                            container.classList.add('active');
                        }
                    });
                });
        });
}
export default initDefaultTabs;
